import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import ROUTES from "../../utils/routes";
import "./style.scss";

// Конец игры (ТЗ #8): все 88 карточек отмечены ЧБ — предлагаем +57 ДО запроса
// отзыва. Согласие -> попап покупки (+57), отказ -> обычный запрос отзыва.
// payload: { gameId }
export default function Extended57OfferModal() {
  const [payload, setPayload] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openModal, closeModal } = useModalActions();

  const accept = () => {
    closeModal(MODAL_TYPES.EXT57_OFFER);
    openModal(MODAL_TYPES.BUY_PRODUCT, {
      productType: "EXTENDED_57",
      gameId: payload?.gameId,
    });
  };

  // Отказ/закрытие ведут в отзыв и считаются его показом: помечаем игру,
  // чтобы гейт в /matches не редиректил в /feedback повторно (перма-редирект).
  const goFeedbackOnce = () => {
    if (payload?.gameId)
      localStorage.setItem(`wepurplay_feedback_gate_${payload.gameId}`, "1");
    navigate(ROUTES.FEEDBACK_PAGE);
  };

  const decline = () => {
    closeModal(MODAL_TYPES.EXT57_OFFER);
    goFeedbackOnce();
  };

  return (
    <BaseModal
      className="extended57-offer-modal"
      eventTypeModal={MODAL_TYPES.EXT57_OFFER}
      onPayload={(data) => data && setPayload(data)}
      onClose={goFeedbackOnce}
      title={t("extended57.offer.title")}
      description={t("extended57.offer.text")}
    >
      <div className="extended57-offer-modal__actions">
        <BaseButton onClick={accept}>{t("extended57.offer.start_btn")}</BaseButton>
        <BaseButton unfilledGradient onClick={decline}>
          {t("extended57.offer.later_btn")}
        </BaseButton>
      </div>
    </BaseModal>
  );
}
